/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import modelTextureURL from './Texture.jpg';
import anchorTextureURL from './Anchor.png';
import shadowTextureURL from './Shadow.png';
import handsTextureURL from './Hands.png';

const modelTexture = new THREE.TextureLoader().load(modelTextureURL);
const anchorTexture = new THREE.TextureLoader().load(anchorTextureURL);
const shadowTexture = new THREE.TextureLoader().load(shadowTextureURL);
const handsTexture = new THREE.TextureLoader().load(handsTextureURL);

let textures = [modelTexture, anchorTexture, shadowTexture, handsTexture];

for (let i = 0; i < textures.length; i++) {
  let texture = textures[i];
  texture.anisotropy = 8.0;
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
}

export { modelTexture as Model };
export { anchorTexture as Anchor };
export { shadowTexture as Shadow };
export { handsTexture as Hands };



// WEBPACK FOOTER //
// ./src/textures/Textures.js